import Stack from '@mui/material/Stack'
import Skeleton from '@mui/material/Skeleton'

export const DaysSkeleton = () => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Skeleton variant="text" height={18} width={50} />
      <Skeleton variant="text" height={18} width={20} />
      <Skeleton variant="text" height={18} width={50} />
    </Stack>
  )
}
